import { ApiNetworkError, ApiRequestError } from '../api/errors';
import type { Translate } from '../i18n/translate';

/**
 * What a public page shows for a failed request. The API's own sentence when it sent one — it is already in
 * the reader's language — and never `caught.message` unguarded: a network failure carries the browser's
 * English, and showing it makes an unreachable API read as a rejected password.
 */
export const publicErrorMessage = (caught: unknown, t: Translate): string => {
  if (caught instanceof ApiNetworkError) {
    return t('login.unreachable');
  }

  if (caught instanceof ApiRequestError) {
    return caught.message;
  }

  // eslint-disable-next-line no-console
  console.error('[bo-admin] Unexpected failure on a public page:', caught);

  return t('login.failed');
};
